import { AxiosError, AxiosResponse } from 'axios'
import { AuthedAxiosRequests } from 'features/auth'

type GcsToken = {
  credentials: string
  bucket: string
  expiry: Date
}

export class RolodexTilesPlugin {
  name: string
  priority: number
  entryID: string
  rootPath: string
  gcsToken: GcsToken | undefined
  axios: AuthedAxiosRequests
  rolodexURL: string

  constructor(options: {
    entryID: string
    rootPath: string
    axios: AuthedAxiosRequests
    rolodexURL: string
  }) {
    this.name = 'ROLODEX_AUTH_PLUGIN'
    this.priority = -Infinity
    this.axios = options.axios

    this.entryID = options.entryID
    this.rootPath = options.rootPath
    this.rolodexURL = options.rolodexURL
  }

  fetchData(url: string, options?: RequestInit) {
    return this._refreshToken().then(async () => {
      if (this.gcsToken === undefined) {
        return Promise.reject()
      }
      const gcsOptions = {
        ...options,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.gcsToken.credentials}`,
          ...options?.headers,
        },
      }
      const fixedURL = fixTileURL(url)

      const sanitizedURL =
        `${this.entryID}/${this.rootPath}/${fixedURL}`.replaceAll('/', '%2F')

      const gcsurl = `https://storage.googleapis.com/storage/v1/b/${this.gcsToken.bucket.slice(5)}/o/${sanitizedURL}?alt=media`

      return fetch(gcsurl, gcsOptions)
    })
  }

  async _refreshToken() {
    if (
      this.gcsToken !== undefined &&
      Date.now() < this.gcsToken.expiry.getTime()
    ) {
      return Promise.resolve()
    }
    // fetch token here
    const url = `${this.rolodexURL}/api/v2/files/shortlivedcreds/${this.entryID}?prefix=${this.rootPath}`
    return this.axios
      .get(url)
      .then(async (res: AxiosResponse) => {
        const data = await res.data
        if (!data.credentials || !data.bucket || !data.expiry) {
          console.error(`Response poorly formatted`, res.status, res)
          return Promise.reject()
        }
        this.gcsToken = {
          credentials: data.credentials,
          bucket: data.bucket,
          expiry: new Date(data.expiry + 'Z'),
        }
        return Promise.resolve()
      })
      .catch((error: AxiosError) => {
        console.error('Issue grabbing rolodex gcs token', error)
        throw error // propagate error so clients can process it in `{error} = useSWR()`
      })
  }
}

//  Hacky fix since there's some underlying assumption TilesRenderer makes about the tileset directory
function fixTileURL(url: string) {
  const substring = 'tileset.json/'
  const position: number = url.indexOf(substring)
  if (position < 0) return url
  return url.substring(position + substring.length)
}
